import React from 'react'
import { connect } from 'react-redux'
import ConfirmUpdateModal from '../ConfirmationModal'
import InputModal from '../InputModal'
import TokenModal from '../TokenModal'

const MODAL_LIST = {
  CONFIRM_UPDATE: ConfirmUpdateModal,
  TOKEN_MODAL: TokenModal,
  INPUT_MODAL: InputModal
}

const ModalRoot = ({ type, props }) => {
  if (!type) {
    return null
  }

  const Component = MODAL_LIST[type]
  return <Component {...props} />
}

export default connect(state => ({
  type: state.modalReducer.type,
  props: state.modalReducer.props
}))(ModalRoot)



// WEBPACK FOOTER //
// ./src/app/modules/ModalRoot/index.js